<template>
  <div class="recharge">
    <div class="step1" v-if="step==1">
      <div class="con bottomline">
        <div class="tit">充值金额</div>
        <div class="inpbox">
            <span>¥</span>
            <input v-model="money" @input="fillIn()" class="weui-input" type="number" placeholder="请输入您要充值的金额">
        </div>
      </div>
      <div class="app-btn-area weui-btn-area">
          <div class="weui-btn" @click="nextstep">充值</div>
          <!-- <div class="weui-btn" @click="nextstepp">充值</div> -->
      </div>
    </div>

    <div class="step2 bottomline" v-if="step==2">
      <div class="tit">充值成功</div>
      <div class="num">￥<span>{{money}}</span></div>
      <div class="app-btn-area weui-btn-area">
          <router-link :to="{ name: 'home' }" class="weui-btn">返回</router-link>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      step:1,
      money:''
    }
  },
  methods:{
      fillIn(){
          if(this.money>0 && !(/^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/).test(this.money)){
            //   console.log(this.money)
            //   this.money = (this.money*1).toFixed(2);
              this.money = Number(this.money.toString().match(/^\d+(?:\.\d{0,2})?/))
          }
        //   this.money = (this.money*1).toFixed(2);
      },
    nextstep(){
      let vm = this;
      if(!(vm.money*1>0)){
        vm.publics.message.danger('请输入金额');
        return false;
      }
      // ^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$
      if(!(/^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/).test(vm.money)){
        vm.publics.message.danger('请输入正确的金额，最多2位小数');
        return false;
      }
      vm.order({"money":vm.money})
      // vm.ajax("account/money/push", "post", {"money":vm.money}, e => {
      //   vm.orderPay(e.data);
      // })
    },
    // nextstepp(){
    //   let vm = this;
    //   vm.money = vm.money*1;
    //   if(!(vm.money>0)){
    //     vm.publics.message.danger('请输入金额');
    //     return false;
    //   }
    //   order({"money":vm.money})
    // },
    order(data) {
      let vm = this;
            var data = JSON.stringify(data);
            var xhr = new XMLHttpRequest();
            xhr.withCredentials = true;

            xhr.addEventListener("readystatechange", function() {
                if (this.readyState === this.DONE) {
                    console.log(this.responseText);

                    /* var req = JSON.parse(this.responseText); */
                    let response = JSON.parse(this.response);

                    if (response.code != 1000) {
                        alert(response.error)
                    } else {

                        // ----- pay weixin ---
                        var req = response.data;
                        console.log(req);

                        if (typeof WeixinJSBridge == "undefined") {
                            if (document.addEventListener) {
                                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                            } else if (document.attachEvent) {
                                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                            }
                        } else {
                            WeixinJSBridge.invoke(
                                'getBrandWCPayRequest', req,
                                function(res) {
                                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                                        // 使用以上方式判断前端返回,微信团队郑重提示：
                                        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                                        if (res.err_msg == "get_brand_wcpay_request:ok") {
                                            // alert("ok")
                                            vm.step = 2;
                                        } else {
                                            // alert("error")
                                                //支付失败/或取消支付跳转页面
                                        }
                                    }
                                });
                        }

                        // -- pay end --
                    }


                }

            });

            xhr.open("POST", vm.publics.API_URL+"account/money/push");
            xhr.setRequestHeader("content-type", "application/json");

            xhr.send(data);

        },
    orderPay(orderInfo){
      let vm = this;
      console.log(orderInfo)
      wx.ready(function () {
          wx.chooseWXPay({
              timestamp: orderInfo.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: orderInfo.nonceStr, // 支付签名随机串，不长于 32 位
              package: orderInfo.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: orderInfo.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: orderInfo.paySign, // 支付签名
              success: function (res) {
                  vm.step = 2;
              },
              cancel(){
                  console.log('支付取消')
                  
              },
              fail(){
                  console.log('支付失败')
                  
              }
          });
      });
        //       appId: "wx98de15f603ff4df5"
        // nonceStr: "Lx1mU6RXISQbK85V"
        // package: "prepay_id=wx171855189226441414f693f63807540000"
        // paySign: "C8D43D345C7A9BE563F8F4386E845F9C"
        // signType: "MD5"
        // timeStamp: "1608202518"

        //         appId: "wx4bb71f6a0100cd58"
        // nonceStr: "5fdb3b749511d"
        // package: "prepay_id=wx17190524574148b890cff927291acb0000"
        // paySign: "63DBDF33AFED80586BD84D73D87CBE2A"
        // signType: "MD5"
        // timestamp: "1608203124"
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/recharge.vue